if (typeof debounce === 'undefined') {
  var debounce = function (fn, wait) {
    let t;
    return function(...args) {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  };
}
/**
 *  @class
 *  @function ThemeHeader
 */

if (!customElements.get('theme-header')) {
  class ThemeHeader extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.header_section = document.querySelector('.header-section');
      this.menu = this.querySelector('#mobile-menu');
      this.toggle = this.querySelector('.mobile-toggle-wrapper');
      this.a_bar = document.querySelector('.announcement-bar-section');

      this.isTransitioning = false;
      this.lastScrollPos = 0;

      document.addEventListener('keyup', (e) => {
        if (e.code && e.code.toUpperCase() === 'ESCAPE') {
          this.toggle.removeAttribute('open');
          this.toggle.classList.remove('active');
        }
      });

      if (this.classList.contains('header-sticky--active')) {
        document.body.classList.add('header-sticky--active');
      }

      this.toggle.querySelector('.mobile-toggle').addEventListener('click', (e) => {
        if (this.toggle.classList.contains('active')) {
          e.preventDefault();
          document.body.classList.remove('overflow-hidden');
          this.toggle.classList.remove('active');
          this.closeAnimation(this.toggle);
        } else {
          document.body.classList.add('overflow-hidden');
          setTimeout(() => {
            this.toggle.classList.add('active');
          });
        }
      });

      // Cache sticky offset once — only needs recalculating on resize, not every scroll
      this._stickyOffset = this.offsetTop;

      // Store bound references for disconnectedCallback cleanup
      this._onScroll = this._scrollHandler.bind(this);
      this._onResize = this._resizeHandler.bind(this);

      // Single passive scroll handler replaces four separate scroll listeners
      window.addEventListener('scroll', this._onScroll, { passive: true });
      // CAKA: ilk boyamada da değişkenler dolsun. Duyuru çubuğu henüz yerleşmemiş
      // olabileceği için bir kare sonra ve load'da tekrar ölç.
      requestAnimationFrame(() => this._scrollHandler());
      window.addEventListener('load', () => this._scrollHandler(), { once: true });

      // Resize handler for values that only change on resize, not scroll
      window.addEventListener('resize', this._onResize, { passive: true });

      // Initial state
      this._scrollHandler();
      this._resizeHandler();

      // Mobile Navigation transparent header support.
      setTimeout(() => {
        this.mobile_nav = document.querySelector('.header-mobile-navigation');
        if (this.mobile_nav && this.classList.contains('transparent--true')) {
          this.mobile_nav.classList.add('is-fixed');
        }
      }, 100);

      this.menu.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
      this.menu.querySelectorAll('.parent-link-back--button').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this._onScroll);
      window.removeEventListener('resize', this._onResize);
    }

    _scrollHandler() {
      // Batch all reads first, then all writes — one layout per scroll tick
      const scrollY        = window.scrollY;
      const headerTop      = this.header_section.getBoundingClientRect().top;
      const headerHeight   = this.clientHeight;

      if (this.classList.contains('header-sticky--active')) {
        this.classList.toggle('is-sticky', scrollY >= this._stickyOffset && scrollY > 0);
      }
      document.documentElement.style.setProperty('--header-offset', headerTop + 'px');
      document.documentElement.style.setProperty('--header-height', headerHeight + 'px');
      // CAKA: --header-height duyuru çubuğunu içermiyor; mega menü karartması bu yüzden
      // header'ın son birkaç pikselinin üstüne biniyordu. Gerçek alt kenarı ayrı yayınla.
      document.documentElement.style.setProperty(
        '--caka-header-bottom', Math.max(0, this.getBoundingClientRect().bottom) + 'px');
      this._handleScrollDirection(scrollY);
    }

    _resizeHandler() {
      // Recache sticky offset after layout changes
      this._stickyOffset = this.offsetTop;

      // Announcement height never changes on scroll, only on resize
      if (this.a_bar) {
        document.documentElement.style.setProperty('--announcement-height', this.a_bar.clientHeight + 'px');
      }
    }

    _handleScrollDirection(scrollY) {
      if (!this.isTransitioning && this.classList.contains('header-hide-menu--active')) {
        if (scrollY < 200) {
          this.showMenu();
        } else if (this.lastScrollPos < scrollY) {
          this.hideMenu();
        } else if (this.lastScrollPos - 5 > scrollY) {
          this.showMenu();
        }
        this.lastScrollPos = scrollY;
      }
    }

    onSummaryClick(event) {
      const summaryElement = event.currentTarget;
      const detailsElement = summaryElement.parentNode;
      const parentMenuElement = detailsElement.closest('.link-container');

      // Clone deferred template on first open
      const tpl = detailsElement.querySelector(':scope > template.mobile-menu-deferred');
      if (tpl) {
        tpl.replaceWith(tpl.content.cloneNode(true));

        // Re-bind listeners for newly cloned elements
        detailsElement.querySelectorAll('.parent-link-back--button').forEach(button =>
          button.addEventListener('click', this.onCloseButtonClick.bind(this))
        );
        detailsElement.querySelectorAll('details.link-container summary').forEach(summary =>
          summary.addEventListener('click', this.onSummaryClick.bind(this))
        );
      }

      if (this.querySelector('.parent-link-back--button')) {
        this.menu.scrollTop = 0;
      }
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
      }, 100);
    }

    onCloseButtonClick(event) {
      event.preventDefault();
      const detailsElement = event.currentTarget.closest('details');
      this.closeSubmenu(detailsElement);
    }

    closeSubmenu(detailsElement) {
      detailsElement.classList.remove('menu-opening');
      this.closeAnimation(detailsElement);
    }

    closeAnimation(detailsElement) {
      let animationStart;

      const handleAnimation = (time) => {
        if (animationStart === undefined) {
          animationStart = time;
        }

        const elapsedTime = time - animationStart;

        if (elapsedTime < 400) {
          window.requestAnimationFrame(handleAnimation);
        } else {
          detailsElement.removeAttribute('open');
        }
      };

      window.requestAnimationFrame(handleAnimation);
    }

    showMenu() {
      this.classList.remove('header--unpin');
      this.isTransitioning = true;
      setTimeout(() => {
        this.lastScrollPos = window.scrollY;
        this.isTransitioning = false;
        this._handleScrollDirection(window.scrollY);
      }, 300);
    }

    hideMenu() {
      if (!this.isTransitioning) {
        this.classList.add('header--unpin');
        this.isTransitioning = true;
        setTimeout(() => {
          this.lastScrollPos = window.scrollY;
          this.isTransitioning = false;
          this._handleScrollDirection(window.scrollY);
        }, 300);
      }
    }
  }
  customElements.define('theme-header', ThemeHeader);
}

if (!customElements.get('full-menu')) {
  class FullMenu extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      // DOM queries moved from constructor to connectedCallback
      this.submenus = this.querySelectorAll('.thb-full-menu > .menu-item-has-children:not(.menu-item-has-megamenu) > .sub-menu');

      document.fonts.ready.then(() => {
        window.addEventListener('resize', debounce(() => {
          this.setMenuHeight();
          if (!this.submenus.length) {
            return;
          }
          this.resizeSubMenus();
        }, 100));
      });

      // Defer layout read until after paint
      requestAnimationFrame(() => this.setMenuHeight());
    }

    resizeSubMenus() {
      // Batch all reads across all submenus first, then apply all writes
      const results = [];
      this.submenus.forEach((submenu) => {
        submenu.querySelectorAll(':scope > .menu-item-has-children > .sub-menu').forEach((subSubmenu) => {
          results.push({
            el: subSubmenu.parentElement,
            overflowing: subSubmenu.getBoundingClientRect().right > window.innerWidth
          });
        });
      });
      results.forEach(({ el, overflowing }) => {
        el.classList.toggle('left-submenu', overflowing);
      });
    }

    setMenuHeight() {
      let h = this.clientHeight;
      if (h > 20) {
        document.documentElement.style.setProperty('--menu-height', h + 'px');
      }
    }
  }

  customElements.define('full-menu', FullMenu);
}
